module.exports = __webpack_public_path__ + "static/Anbaugebiet-Mittelrhein-600x601-8af6415474c7be2f7a8e517339731f6c.jpeg";